





















































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import PinIcon from '@/components/icons/Pin.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import DateUtils from '@/utils/DateUtils';
import { removeTrailingZeros } from '@/utils/moneyFormarter';
import segmentIo from '@/utils/segment.io';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';

const days = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

@Component({
  components: { Typography, PinIcon, CoinsIcon, CalendarIcon }
})
export default class BillingPlanOverview extends Vue {
  @Prop() hasLinkTerms?: boolean;
  @Prop({ default: {} }) subscription!: any;

  get locationsAmount() {
    return this.subscription.totalLocations || ' ';
  }

  get coinsAmount() {
    if (!this.subscription.totalFee) return ' ';

    return removeTrailingZeros(this.subscription.totalFee || 0);
  }

  get fromDate() {
    return DateUtils.formattedDate({
      date: this.subscription.startAt || new Date()
    });
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get weekDay() {
    return days[(this.subscription.paymentDay || 1) - 1];
  }

  onClickLink() {
    segmentIo.track('Clicked Coin Network Terms Link');
  }
}
